module.exports = __webpack_public_path__ + "img/skin-texture.c2d62b31.svg";